import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const pt: TTranslations = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Aprendizado',
    PAGE_SUBTITLE:
      'Visualize o consumo da plataforma de aprendizado. Cursos próprios vs catálogo Crehana, evolução trimestral, certificações e satisfação.',
    NEW_TAG: 'Novo',
    FRESHNESS_PREFIX: 'Última atualização:',
    FRESHNESS_DATE: '14 mai, 09:00 AM',
    PRODUCT_SELECTOR_LABEL: 'Produto',
    PRODUCT_SELECTOR_HELPER: 'Selecione o produto que deseja analisar',
    PRODUCT_GENERAL: 'Geral',
    PRODUCT_LEARNING: 'Aprendizado',
    BREADCRUMB_ROOT: 'Analytics Hub',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_LEARNING: 'Aprendizado',
    TAB_GENERAL: 'Geral',
    TAB_PATHS: 'Por trilhas',
    TAB_COURSES: 'Por cursos',
    TAB_USERS: 'Por usuários',
    TAB_PLACEHOLDER_PATHS: 'Conteúdo de trilhas em breve',
    TAB_PLACEHOLDER_COURSES: 'Conteúdo de cursos em breve',
    TAB_PLACEHOLDER_USERS: 'Conteúdo de usuários em breve',
    EMPTY_TITLE: 'Nenhum módulo disponível',
    EMPTY_DESCRIPTION: 'Quando houver dados de aprendizado, você os verá aqui.',
    ERROR_TITLE: 'Erro ao carregar o dashboard',
    ERROR_RETRY: 'Tentar novamente',
  },
};
